import React, { useEffect, useContext, createContext, useCallback } from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
// utilities
import { HEADER_CONSTANTS, LINE_WORKS_STATUS_CODE, DIRECT_STATUS_CODE } from '../utilities/constants';
import urlParamManager from '../utilities/urlParamManager';
import { useFetchDataWithToken } from '../utilities/useFetchData';
// components
import { ConferencePageHeader } from '../components/PageHeader';
import LwDescription from '../components/externalService/LwDescription';
import DirectDescription from '../components/externalService/DirectDescription';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
// services
import SessionStorageService from '../services/utilities/SessionStorageService';
import ExternalServiceCooperationStatusApi from '../services/ExternalServiceCooperationStatusApi';
import DirectNoticeUnapprovedWorkSettingsApi from '../services/DirectNoticeUnapprovedWorkSettingsApi';
import DirectNoticeUnapprovedWorkSetting from '../services/directNotice/UnapprovedWorkSetting';

const reloadExternalServiceCooperationPageContext = createContext(() => {});
const useGetReloadExternalServiceCooperationPage = () => {
  const reloadExternalServiceCooperationPage = useContext(
    reloadExternalServiceCooperationPageContext
  );
  return reloadExternalServiceCooperationPage;
};

const vwContext = createContext(null);
const useGetVw = () => {
  const vw = useContext(vwContext);
  return vw;
};

const directNoticeUnapprovedWorkSettingDataContext = createContext(
  new DirectNoticeUnapprovedWorkSetting(
    DirectNoticeUnapprovedWorkSettingsApi.show.get_default_response()
  )
);
const useGetDirectNoticeUnapprovedWorkSettingData = () => {
  const directNoticeUnapprovedWorkSetting = useContext(
    directNoticeUnapprovedWorkSettingDataContext
  );
  return directNoticeUnapprovedWorkSetting;
};

const getLwStatusCode = (data) => {
  return _.get(
    data,
    'data.entities.line_works.reason_code',
    LINE_WORKS_STATUS_CODE.ERROR
  )
}

const getDirectStatusCode = (data) => {
  return _.get(
    data,
    'data.entities.direct.reason_code',
    DIRECT_STATUS_CODE.ERROR
  );
}

/**
 * 外部サービス連携
 *
 * @export
 * @function ExternalServiceCooperation
 */
function ExternalServiceCooperation(props) {
  const fieldId = SessionStorageService.getFieldId();
  const {
    data: statusCodeData,
    reloadAction: statusCodeReloadAction,
    isLodaing: statusCodeLoading,
  } = useFetchDataWithToken(
    ExternalServiceCooperationStatusApi.list.get_options({
      field_id: fieldId,
    }),
    ExternalServiceCooperationStatusApi.list.get_default_response()
  );
  const lwStatusCode = getLwStatusCode(statusCodeData)
  const directStatusCode = getDirectStatusCode(statusCodeData)
  // NOTE：将来的にExternalServiceCooperationStatusApiで判定させるようにする。
  const isShowDirectDescription = SessionStorageService.getUseDirectCooperationFlag();
  const {
    data: noticeSettingsResponse,
    reloadAction: noticeSettingsReloadAction,
    isLodaing: noticeSettingLoading,
  } = useFetchDataWithToken(
    DirectNoticeUnapprovedWorkSettingsApi.show.get_options(fieldId),
    DirectNoticeUnapprovedWorkSettingsApi.show.get_default_response(),
    true,
    true,
    directStatusCode === DIRECT_STATUS_CODE.INUSE
  );
  const directNoticeUnapprovedWorkSetting = new DirectNoticeUnapprovedWorkSetting(
    _.get(
      noticeSettingsResponse,
      'data.entities',
      _.get(
        DirectNoticeUnapprovedWorkSettingsApi.show.get_default_response(),
        'data.entities'
      )
    )
  );
  const reloadAction = useCallback(async() => {
    const retrunData = await statusCodeReloadAction();
    if (getDirectStatusCode(retrunData) === DIRECT_STATUS_CODE.INUSE) {
      noticeSettingsReloadAction();
    }
  }, [statusCodeReloadAction, noticeSettingsReloadAction]);
  const isLoading = statusCodeLoading || noticeSettingLoading;

  const ProviderWrap = ({ children }) => {
    return (
      <reloadExternalServiceCooperationPageContext.Provider
        value={reloadAction}
      >
        <vwContext.Provider value={props.vw}>
          <directNoticeUnapprovedWorkSettingDataContext.Provider
            value={directNoticeUnapprovedWorkSetting}
          >
            {children}
          </directNoticeUnapprovedWorkSettingDataContext.Provider>
        </vwContext.Provider>
      </reloadExternalServiceCooperationPageContext.Provider>
    );
  };

  useEffect(() => {
    const reOpenSlide = (urlparam, masterparam, slide) => {
      // Slideを操作すると毎回呼ばれるのでExternalServiceCooperationを表示している場合のみ
      if (
        _.get(urlparam, '[0]') === 'ExternalServiceCooperation:1' &&
        _.toString(_.get(slide, '[0]')) === '0'
      ) {
        reloadAction();
      }
    };
    urlParamManager.pageWillLoad(reOpenSlide);
    return () => {
      urlParamManager.removePageWillLoad(reOpenSlide);
    };
  }, [reloadAction]);

  return (
    <div id='main' className='main'>
      <Helmet>
        <title>{HEADER_CONSTANTS.conference} - 外部サービス連携</title>
      </Helmet>
      <ConferencePageHeader title={'外部サービス連携'} />
      {isLoading ? null : (
        <ProviderWrap>
          <div className='main__body ExternalServiceCooperation'>
            <FormList>
              {/* NOTE: FormListSubHeaderを使用したいためにFormListを使用 */}
              <FormListSubHeader noMarginTop title='チャットサービス' />
              <div className='ExternalServiceCooperation__item'>
                <LwDescription status_code={lwStatusCode} />
              </div>
              {isShowDirectDescription && (
                <div className='ExternalServiceCooperation__item'>
                  <DirectDescription status_code={directStatusCode} />
                </div>
              )}
            </FormList>
          </div>
        </ProviderWrap>
      )}
    </div>
  );
}
export {
  ExternalServiceCooperation,
  useGetReloadExternalServiceCooperationPage,
  useGetVw,
  useGetDirectNoticeUnapprovedWorkSettingData,
};



// WEBPACK FOOTER //
// ./src/pages/ExternalServiceCooperation.jsx